/**
 * Persist onboarding dismissal per browser profile (localStorage).
 * Migrates legacy ``sessionStorage.onboardingCompleted`` once.
 */
const LOCAL_KEY = "kan_onboarding_completed_v1";
const LEGACY_SESSION_KEY = "onboardingCompleted";

export function hasCompletedOnboarding(): boolean {
  try {
    if (localStorage.getItem(LOCAL_KEY) === "true") {
      return true;
    }
    if (typeof sessionStorage !== "undefined" && sessionStorage.getItem(LEGACY_SESSION_KEY) === "true") {
      localStorage.setItem(LOCAL_KEY, "true");
      sessionStorage.removeItem(LEGACY_SESSION_KEY);
      return true;
    }
  } catch {
    /* private mode / quota */
  }
  return false;
}

export function markOnboardingCompleted(): void {
  try {
    localStorage.setItem(LOCAL_KEY, "true");
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem(LEGACY_SESSION_KEY);
    }
  } catch {
    /* ignore */
  }
}
